import React, { useState } from 'react';
import {
  NavigationContainer,
  useNavigationContainerRef,
} from '@react-navigation/native';
import { Theme } from '@oneamerica/dxp-ui-components';
import getLinks from './linking';
import RouteConstants from '../constants/RouteConstants';
import { titleCase } from '../utils';
import { createStackNavigator } from '@react-navigation/stack';
import GuestPayment from '../screens/GuestPayment';
import GuestHeader from '../components/GuestHeader';
import { trackCustomEvent } from '../utils/Analytics/AdobeAnalyticsUtils';
import { analyticsTags } from '../utils/Analytics/AnalyticsTags';

const GuestHeaderComponent = () => <GuestHeader />;

const GuestNavigation = (props) => {
  const [currentRoute, setCurrentRoute] = useState(RouteConstants.home);
  const navigationRef = useNavigationContainerRef<Record<string, any>>();
  //@ts-ignore
  const queryParams = globalThis.location.search;
  const params = new URLSearchParams(queryParams);
  const initialParams = Object.fromEntries(params.entries());
  const Stack = createStackNavigator();

  const setNavState = (state) => {
    const route = state?.routeNames?.[state?.index];
    if (route) {
      route !== currentRoute && setCurrentRoute(route);
    }
  };

  const onReady = () => {
    setNavState(navigationRef?.current?.getRootState());

    // Clean URL parameters immediately when navigation is ready
    // This handles cases where the component mounts with URL parameters
    try {
      const url = new URL(globalThis.location.href);
      const hasParams =
        url.searchParams.has('paymentStatus') ||
        url.searchParams.has('account');
      if (hasParams) {
        if (url.searchParams.get('paymentStatus') === 'success') {
          trackCustomEvent(analyticsTags.CaptureGuestPaymentSuccessTag);
        }
        if (url.searchParams.get('paymentStatus') === 'cancel') {
          trackCustomEvent(analyticsTags.CaptureGuestPaymentCancelTag);
        }

        // Let the GuestPayment component handle the initial logic first
        // Then clean the URL after a brief delay
        setTimeout(() => {
          const cleanUrl = new URL(globalThis.location.href);
          cleanUrl.searchParams.delete('paymentStatus');
          cleanUrl.searchParams.delete('account');
          globalThis.history.replaceState(null, '', cleanUrl.toString());
        }, 100);
      }
    } catch (error) {
      console.log('Error cleaning URL parameters on ready:', error);
    }
  };

  // set nav info on change
  const onStateChange = (state) => {
    // dispatch redux action to force regular token refresh check
    setNavState(state);

    const currentRoute = navigationRef?.current?.getCurrentRoute();
    const routeParams = currentRoute?.params as Record<string, any>;

    // Clear payment status and account parameters from both navigation and URL
    if (routeParams?.paymentStatus || routeParams?.account) {
      // Clear from navigation params
      navigationRef.current?.setParams({
        paymentStatus: undefined,
        account: undefined,
      });

      // Also clean the actual browser URL comprehensively
      try {
        const url = new URL(globalThis.location.href);
        url.searchParams.delete('paymentStatus');
        url.searchParams.delete('account');
        globalThis.history.replaceState(null, '', url.toString());
      } catch (error) {
        console.log('Error cleaning URL parameters:', error);
      }
    }
  };

  return (
    <NavigationContainer
      ref={navigationRef}
      linking={{
        prefixes: ['localhost:8080', '127.0.0.1:8080'],
        config: {
          screens: { '/': { screens: getLinks() } },
        },
      }}
      documentTitle={{
        formatter: (options, route) =>
          `${
            options?.documentTitle ??
            options?.title ??
            titleCase(route?.name.replaceAll('-', ' '))
          } - OneAmerica Financial`,
      }}
      onStateChange={onStateChange}
      onReady={onReady}
    >
      <Theme.ResponsiveProvider>
        <GuestHeaderComponent />
        <Stack.Navigator
          screenOptions={{
            headerShown: false,
          }}
        >
          <Stack.Screen
            name={RouteConstants.guestpayments}
            component={GuestPayment}
            initialParams={initialParams}
          />
        </Stack.Navigator>
      </Theme.ResponsiveProvider>
    </NavigationContainer>
  );
};

export default GuestNavigation;
